import "./Feedback.css"

import { Col } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { FaArrowRightLong } from "react-icons/fa6"
import { useNavigate } from "react-router"

import LongText from "@/components/LongText/LongText"
import type { HomeLatestFeedback } from "@/types/homeTypes"
import { isRTL } from "@/utils/helpers"

export default function FeedbackCard({ ele }: { ele: HomeLatestFeedback }) {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <Col lg={4}>
      <div
        className="home-section-card d-flex flex-column h-100"
        style={{ padding: "20px", transition: "transform 0.2s ease" }}
      >
        <div className="mb-3 d-flex align-items-center gap-2">
          <div
            className="bg-primary opacity-10 rounded-circle"
            style={{ width: "8px", height: "8px" }}
          ></div>
          <h6 className="m-0 fw-bold text-dark">{ele?.lecture?.name}</h6>
        </div>

        <div
          className="flex-grow-1 mb-4"
          style={{
            direction: isRTL(ele?.content) ? "rtl" : "ltr",
            textAlign: isRTL(ele?.content) ? "right" : "left",
            fontSize: "0.95rem",
            color: "#555",
            lineHeight: "1.6",
          }}
        >
          {(() => {
            const type = Number(ele?.type)
            if (type === 0 && ele?.content) {
              return <LongText text={ele?.content} />
            } else if (type === 1) {
              return (
                <div className="bg-light p-2 rounded-3">
                  <audio className="w-100" controls style={{ height: "32px" }}>
                    <source src={ele.content} type="audio/wav" />
                  </audio>
                </div>
              )
            } else {
              return <span className="text-muted italic">--</span>
            }
          })()}
        </div>

        <div
          className="mt-auto pt-3 border-top d-flex align-items-center justify-content-between text-primary fw-semibold"
          style={{ cursor: "pointer", fontSize: "0.9rem" }}
          onClick={() => navigate("/feedbacks")}
        >
          <span>{t("buttons.seeAll")}</span>
          <FaArrowRightLong
            className={isRTL(t("buttons.seeAll")) ? "rotated180" : ""}
          />
        </div>
      </div>
    </Col>
  )
}
